<template>
    <Modal class-name="scrollable vertical-center-modal" title="Nueva escala" v-model="show" :footer-hide="true" :scrollable="true">
        <Form style="width: 100%" ref="scaleForm" :model="evaluation" :rules="ruleInline">
            <Row :gutter="16">
                <i-col span="24">
                    <FormItem label="Categoría" prop="category">
                        <Select v-model="evaluation.category" style="width: 100%">
                            <Option value="TDC">Teoría del cambio</Option>
                            <Option value="POA">POA</Option>
                            <Option value="Desempeño">Desempeño</Option>
                            <Option value="Competencias">Competencias</Option>
                             <Option value="Ev-Trans">Evaluación transversal</Option>
                        </Select>
                    </FormItem>
                </i-col>
                <i-col span="24">
                    <FormItem label="Nombre" prop="name">
                        <Input v-model="evaluation.name" placeholder="" />
                    </FormItem>
                </i-col>
                <i-col span="24">
                    <FormItem label="Nombre corto" prop="short_name">
                        <Input v-model="evaluation.short_name" placeholder="" />
                    </FormItem>
                </i-col>
                <i-col span="24">
                    <FormItem label="Descripción" prop="description">
                        <Input type="textarea" :autosize="{minRows: 3,maxRows: 5}" v-model="evaluation.description" placeholder="" />
                    </FormItem>
                </i-col>
                <i-col span="24">
                    <FormItem label="Cólor" prop="hex_color">
                        <Input v-model="evaluation.hex_color" placeholder="#ECECEC" />
                    </FormItem>
                </i-col>
                <i-col span="24">
                    <FormItem label="Puntos" prop="score">
                        <Input type="number" v-model="evaluation.score" placeholder="" />
                    </FormItem>
                </i-col>
                <i-col span="24">
                    <Button style="margin-top: 25px" size="large" long type="primary" :loading="loading" @click="save">Agregar</Button>
                </i-col>
            </Row>
        </Form>
    </Modal>
</template>

<script>
    export default {
        data(){
            return {
                show: false,
                loading: false,
                evaluation: {
                    name: '',
                    short_name: '',
                    category: 'TDC',
                    description: '',
                    hex_color: '',
                    score: 0,
                },
                ruleInline: {
                    category: [
                        { required: true, message: 'Categoría es requerido', trigger: 'change' }
                    ],
                    name: [
                        { required: true, message: 'Nombre es requerido', trigger: 'change' }
                    ],
                    short_name: [
                        { required: true, message: 'Código es requerido', trigger: 'change' }
                    ],
                },
            }
        },
        methods: {
            save(){
                this.$refs.scaleForm.validate(valid => {
                    if(valid){
                        this.loading = true
                        window.axios.post(this.$root.API_URL + '/evaluation/create-scale', { ...this.evaluation })
                        .then(response => {
                            if(response.data.success){
                                window.EventBus.$emit('evaluation-scales--add', response.data.scale)
                                this.show = false
                                this.loading = false
                                this.clear()
                            }
                        })
                    }
                })
            },
            clear(){
                this.evaluation = {
                    name: '',
                    short_name: '',
                    category: 'result',
                    description: '',
                    hex_color: '',
                    score: 0,
                }
            }
        },
        mounted(){
            window.EventBus.$on('evaluation-scales--create', () => {
                this.show = true
            })
        }
    }
</script>